module.exports = __webpack_public_path__ + "img/help-other.56722c21.svg";